"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lugagnano-val-d-arda": {
    "973926fc": [{
      "hkey": "4e865516",
      "slug": "lugagnano-val-d-arda",
      "name": "Lugagnano Val d'Arda",
      "primary": true,
      "skipSearch": false
    }],
    "montezago": [{
      "hkey": "4e865516",
      "slug": "lugagnano-val-d-arda",
      "name": "Lugagnano Val d'Arda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;